import * as e from "react";
const l = (t) => /* @__PURE__ */ e.createElement("svg", { width: 18, height: 10, viewBox: "0 0 18 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ e.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.115 0L9 6.18084L15.885 0L18 1.90283L9 10L0 1.90283L2.115 0Z", fill: "#444444" }));
export {
  l as S
};
